import _ from 'lodash';
import {ReactNode} from 'react';
import {ModalType} from '@treez-ui/core/feedback/modals';
import {ButtonClass} from '@treez-ui/core/buttons/Button';
import {FeedbackAction, OpenFeedbackValue} from '~/redux/actions/UserFeedbackActions';
import {ReducerActionAttributes} from './RootReducer';

export interface UserFeedbackState {
    action: () => void;
    bodyElement?: ReactNode;
    bodyText?: string;
    buttonClass?: ButtonClass;
    buttonIcon?: ReactNode;
    buttonText?: string;
    cancelOption?: boolean;
    onCancel?: () => void;
    open: boolean;
    title: string;
    type?: ModalType;
}

const DEFAULT_FEEDBACK_STATE = {
    bodyText: '',
    buttonClass: ButtonClass.BASIC,
    buttonText: 'Ok',
    cancelOption: false,
    open: false,
    title: '',
    type: ModalType.INFORMATION,
};

const {CLOSE_FEEDBACK_MODAL, OPEN_FEEDBACK_MODAL} = FeedbackAction;

const UserFeedbackReducer = (
    state = DEFAULT_FEEDBACK_STATE,
    action: ReducerActionAttributes<FeedbackAction, OpenFeedbackValue>
) => {
    const {type, value} = action;

    switch (type) {
        case CLOSE_FEEDBACK_MODAL:
            return DEFAULT_FEEDBACK_STATE;
        case OPEN_FEEDBACK_MODAL:
            return {
                ...state,
                ...value,
                open: true,
            };
        default:
            return state;
    }
};

export default UserFeedbackReducer;
